import React, { useEffect } from "react";
import { Modal, Button, Header } from "semantic-ui-react";
import WithEventWarning from "../WithEventWarning/WithEventWarning";
import SharedFunctions from "../../utils/SharedFunctions";
import { PARTIAL_DELIVERY_CONFIRMATION_MODAL } from "../../utils/constants/componentConstants";

const PartialDeliveryConfirmationModal = ({
  open,
  cancelCallback,
  continueCallback,
  className,
}) => {
  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(PARTIAL_DELIVERY_CONFIRMATION_MODAL);
    }
    if (open) {
      onOpen();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={cancelCallback}
      size="small"
      closeOnEscape={false}
      closeOnDimmerClick={false}
      className={className}
    >
      <Header icon="warning sign" color="red" content={"Varning!"} />
      <Modal.Content>
        <h1>{`Vill du verkligen delleverera denna order?`}</h1>
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={cancelCallback}>
          NEJ
        </Button>
        <Button primary onClick={continueCallback}>
          JA
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WithEventWarning(PartialDeliveryConfirmationModal);
